<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const { params, query, path } = useRoute()
const store = useCategoryStore()
await store.init({ id: params.id, query, url: path })
const { productsData, baseCategory, newProducts, blog, name, description, descriptionFooter, category_youtubeId, media, breadcrumbs, subcategoryTypeField, category_subcategoryH2, availableSortings, metaTitle, metaDescription } = storeToRefs(store)

let param = Object.entries(Object.fromEntries(Object.entries(query).filter(([key]) => ['min-price', 'max-price', 'properties', 'order', 'p'].includes(key)))).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
let robots = 'index,follow'
if (param.length) {
  param = `?${param}`
  robots = 'noindex,follow'
}
useHead({
  titleTemplate: `${metaTitle.value} - %s`,
  meta: [
    { name: 'description', content: metaDescription.value },
    { name: 'robots', content: robots }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${path}${param}` }
  ]
})

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': runtimeConfig.public.baseUrl,
          name: 'Go-Racing'
        }
      },
      ...breadcrumbs.value.map(({ name, url, urlPrefix }: any, index: number) => ({
        '@type': 'ListItem',
        position: index + 2,
        item: {
          '@id': `${runtimeConfig.public.baseUrl}/${urlPrefix}/${url}`,
          name
        }
      }))
    ]
  }),
  defineItemList({
    name: name,
    url: `${runtimeConfig.public.baseUrl}${path}`,
    description: metaDescription.value,
    itemListElement: productsData.value.elements.map(({ name, seoUrls, extensions: { urlPrefix: { prefix } } }: any, index: number) => ({
        '@type': 'ListItem',
        position: index + 1,
        name,
        url: `${runtimeConfig.public.baseUrl}/${prefix}/${seoUrls?.[0].seoPathInfo}`
    })),
    numberOfItems: productsData.value.elements.length
  })
])
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <div class="flex gap-[50px] mb-[50px]">
      <div class="w-full md:w-1/5 hidden md:block">
        <FiltersDesktop v-if="productsData.elements.length" class="mb-[50px]" />
        <ProductListNew :products="newProducts" />
      </div>
      <div class="w-full md:w-3/4">
        <h1 class="text-18 font-bold mb-[20px]">
          {{ name }}
        </h1>
        <!-- ! promotion 20.04.2026 banner start -->
         <!-- <div class="mb-[15px]">
          <NuxtLink to="/k/bestsellery" class="justify-center relative hidden xs:block">
            <Img
              src="/banners/kategoria_mobile.jpg?t=1748327127"
              width="737"
              height="200"
              alt=""
            />
          </NuxtLink>
          <NuxtLink to="/k/przejazdzki-dla-dzieci" class="justify-center relative hidden sm:block">
            <Img
              src="/banners/kategoria_desktop.jpg?t=1748327127"
              width="855"
              height="200"
              alt=""
            />
          </NuxtLink>
        </div> -->
        <!-- ! promotion 03.05.2026 (including) banner end -->

        <div v-if="media || description" class="flex flex-col md:flex-row-reverse justify-between items-center md:items-start mb-[20px] md:gap-[30px]">
          <Img
            v-if="media"
            :src="media.url"
            :width="media.metaData.width.toString()"
            :height="media.metaData.height.toString()"
            :alt="media.alt"
            class="flex justify-end min-w-[33.333333%] mb-[15px]"
          />
          <More v-if="description" :html="formatHtml(description)" class="format-html" :height="58" />
        </div>
        <Subcategory v-if="baseCategory?.length && subcategoryTypeField !== 'inactive'" :subcategory-type-field="subcategoryTypeField" :subcategory="baseCategory" class="mb-[20px]" />
        <ProductListRecommended class="mb-[20px] md:mb-0" />
        <div v-if="productsData.elements.length" :class="{ 'justify-between': category_subcategoryH2, 'justify-end': !category_subcategoryH2 }" class="grid grid-cols-3 gap-[10px] md:flex items-center mb-[20px]">
          <h2 v-if="category_subcategoryH2" class="col-span-3 text-18 font-bold">
            {{ category_subcategoryH2 }}
          </h2>
          <FiltersMobile class="col-span-2 md:hidden" />
          <Sort :available-sortings="availableSortings" />
        </div>
        <ProductListCategory v-if="productsData.elements.length" class="mb-[50px]" />
      </div>
    </div>
    <Youtube v-if="category_youtubeId" :id="category_youtubeId" class="!h-[355px] md:!h-[455px] mb-[20px]" />
    <div v-if="descriptionFooter" v-html="formatHtml(descriptionFooter)" class="format-html mb-[50px]" />
    <Blog v-if="blog.length" :blog="blog" class="mb-[50px]" />
  </div>
</template>
